const Condition = require( './Condition' );

const SummonedCondition = function( instigator, owner, battleState, duration ) {
	const condition = new Condition( instigator, owner, battleState );
	condition.duration = duration;
	condition.handle = 'summoned';

	condition.initInterval( condition.expire, duration );
	if( battleState.paused ) {
		condition.intervalTimer.pause();
	}

	return condition;
};
module.exports = SummonedCondition
